<template>
  <div
      v-if="showComponent && onReady"
      :key="componentRefresh"
  >
    <!-- create/edit mode modal -->
    <ks-modal
        :ref="`${id}_mode_modal`"
        :disabled="true"
        size="lg"
        :backdropClose="false"
        :title="`${!copySelectedMode.id?'Create Mode':`Edit Mode ${copySelectedMode.mode_name}`}`">
      <ks-modal-body>
        <ul class="nav nav-tabs" id="mode" role="tablist">
          <li class="nav-item">
            <a class="nav-link active" id="modeFormFilters-tab" data-toggle="tab" href="#modeFormFilters" role="tab"
               aria-controls="modeFormFilters" aria-selected="true">Basic</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" id="modeJSON-tab" data-toggle="tab" href="#modeJSON" role="tab"
               aria-controls="modeJSON" aria-selected="false">Advanced (JSON)</a>
          </li>
        </ul>
        <div class="tab-content" id="modeContent">
          <div class="tab-pane fade show active" id="modeFormFilters" role="tabpanel"
               aria-labelledby="modeFormFilters-tab"
               style="height: 550px;overflow-y: scroll;overflow-x: hidden;padding-right: 10px;padding-top: 15px;padding-left: 5px;">
            <form id="d-mode-form">
              <div class="row">
                <div class="col-12 col-md-5">
                  <label for="d-mode-modeName">Name</label>
                    <input
                        type="text"
                        class="form-control form-control-sm"
                        v-model="copySelectedMode.mode_name"
                        id="d-mode-modeName"
                        required
                    >
                </div>
                <div class="col-12 col-md-5">
                  <label for="d-mode-icon">Icon</label>
                    <input
                        type="text"
                        class="form-control form-control-sm"
                        placeholder="fas fa-save"
                        v-model="copySelectedMode.icon"
                        id="d-mode-icon"
                    >
                </div>
                <div class="col-12 col-md-2">
                  <ks-flex wrap="nowrap" align="center" justify="end">
                  <label for="quick-icon" class="form-label pr-2">Quick Icon</label>
                  <input
                      type="checkbox"
                      v-model="copySelectedMode.display_quick_icon"
                      id="quick-icon"
                  >
                  </ks-flex>
                </div>
              </div>
              <hr>
              <div class="mb-1 row" v-for="(value, key) in copySelectedMode.mode_json.filters">
                <template v-if="key !== 'campaign_id'">
                  <label
                      :for="`d-mode-filter-${key}`"
                      class="form-label col-sm-4"
                  >
                    {{ key }}
                  </label>
                  <div class="col-sm-8">
                    <input
                        type="text"
                        class="form-control form-control-sm"
                        list="d-mode-filter-token-list"
                        v-model="copySelectedMode.mode_json.filters[key]"
                        :id="`d-mode-filter-${key}`"
                    >
                    <datalist id="d-mode-filter-token-list">
                      <option :value="token" v-for="token in tokenList"/>
                    </datalist>
                  </div>
                </template>
              </div>
            </form>
          </div>
          <div class="tab-pane fade" id="modeJSON" role="tabpanel" aria-labelledby="modeJSON-tab">
            <div class="form-group">
              <textarea class="form-control" rows="25" v-model="copySelectedModeJSON"></textarea>
            </div>
          </div>
        </div>
      </ks-modal-body>
      <ks-modal-footer>
        <button
            type="button"
            @click.prevent="copySelectedMode.id ? updateMode() : createMode()"
            class="btn btn-primary btn-sm"
        >
          Save <i class="fas fa-save"></i>
        </button>
        <button
            type="button"
            @click.prevent="cancelMode"
            class="btn btn-danger btn-sm"
        >
          Cancel <i class="fas fa-ban"></i>
        </button>
      </ks-modal-footer>
    </ks-modal>
  </div>
</template>


<script>
import checkPermissions from '../../mixins/checkPermissions';
import onMountedDataProvider from '../../mixins/onMountedDataProvider';
import objectValuesByToken from '../../helpers/objectValuesByToken';
import _ from 'lodash'
import Vuex from 'vuex'

export default {
  name:     "ks-mode-crud-modal",
  mixins:   [checkPermissions, onMountedDataProvider],
  props:    {
    dataProvider: {type: String, required: true},
  },
  computed: {
    ...Vuex.mapGetters({auth: 'rms_ui/auth/auth'}),
    modes() {
      return this.data_provider_ref.modes;
    },
    selectedMode() {
      return this.data_provider_ref.selectedMode;
    },
    isAdminUser() {
      return app.auth.user.id === 1;
    },
    copySelectedModeJSON: {
      get() {
        return JSON.stringify(this.copySelectedMode, null, 2)
      },
      set(newValue) {
        try {
          let json              = JSON.parse(newValue);
          this.copySelectedMode = json;
        } catch (err) {
        }
      }
    }
  },
  methods:  {
    modeSelected(dataMode) {
      this.data_provider_ref.selectModeByName(dataMode.mode_name, true);
      this.$emit('onModeChange');
    },
    cancelMode() {
      this.copySelectedMode = {
        id:        null,
        mode_name: null,
        icon:      null,
        mode_json: {filters: {}, orderBy: null, skip: null, pageSize: null, page: null, components: null}
      };
      this.$refs[`${this.id}_mode_modal`].hide();
    },
    async createMode() {
      let validate = $('#d-mode-form')[0].reportValidity();
      if (this.copySelectedMode.mode_name !== null && this.copySelectedMode.mode_name.length > 0 && validate) {
        try {
          this.copySelectedMode.mode_json.filters = await this.sanitaze(this.copySelectedMode.mode_json.filters);
          let res                                 = await this.data_provider_ref.insertMode(this.copySelectedMode);
          let newMode                             = {...this.copySelectedMode, id: res.create[0].id};
          this.modes.push(newMode);
          this.data_provider_ref.selectModeByName(this.copySelectedMode.mode_name, true);
          this.cancelMode();
        } catch (err) {
          console.log('KS-APP: data-mode', err);
        }
      }
    },
    async updateMode() {
      let validate = $('#d-mode-form')[0].reportValidity();
      if (!_.isEqual(this.copySelectedMode, this.selectedMode) && validate) {
        let confirm = window.confirm(`Are you sure to save this options for ${this.copySelectedMode.mode_name}?`);
        if (confirm) {
          try {
            this.copySelectedMode.mode_json.filters = await this.sanitaze(this.copySelectedMode.mode_json.filters);
            await this.data_provider_ref.updateMode(this.copySelectedMode);
            await this.data_provider_ref.loadModeList();
            await this.data_provider_ref.selectModeByName(this.copySelectedMode.mode_name, true);
            this.cancelMode();
          } catch (err) {
            console.log('KS-APP: data-mode', err);
          }
        }
      }
    },
    async openModeModal(type) {
      if (type == 'edit') {
        this.copySelectedMode = JSON.parse(JSON.stringify(this.selectedMode));
      } else {
        this.copySelectedMode = {
          id:                 null,
          mode_name:          null,
          data_provider_name: this.data_provider_ref.id,
          icon:               null,
          mode_json:          {
            filters:    this.data_provider_ref.getFilters(),
            orderBy:    this.data_provider_ref.getOrderBy(),
            skip:       this.data_provider_ref.recordsToSkipForNextPage,
            pageSize:   this.data_provider_ref.getPageSize(),
            page:       this.data_provider_ref.getPage(),
            components: this.data_provider_ref.getComponentsConfiguration()
          }
        }
      }
      this.$refs[`${this.id}_mode_modal`].show();
    },
    sanitaze(obj) {
      return new Promise((resolve) => {
        for (let key in obj) {
          if (obj[key] !== null) {
            if (!isNaN(obj[key]) && obj[key].length > 0) obj[key] = obj[key] * 1;
            else if (obj[key] == 'true') obj[key] = 1;
            else if (obj[key] == 'false') obj[key] = 0;
            else if (obj[key] == 'null') obj[key] = null;
            else if (obj[key].length == 0) obj[key] = null;
          }
        }
        resolve(obj);
      })
    }
  },
  async mounted() {
    await this.onMountedDataProvider();
  },
  data() {
    return {
      newMode:          {
        mode_name:          null,
        icon:               null,
        display_quick_icon: false
      },
      tokenList:        objectValuesByToken.list,
      copySelectedMode: {
        id:                 null,
        mode_name:          null,
        icon:               null,
        display_quick_icon: false,
        mode_json:          {filters: {}, orderBy: null, skip: null, pageSize: null, page: null, components: null}
      }
    }
  }
}
</script>

<style>
.active-mode {
  background-color: #dddddd;
}

.dropdown-toggle-mode::after {
  float: right !important;
  margin-top: 8px !important;
}
</style>
